/*
 * Build-Your-Own-Box cart lock
 * ----------------------------
 * <bundle-remove-button> removes every cart line sharing the same _bundle_id
 * in a single /cart/update.js call, then re-renders the cart sections in place
 * (keeping the cart drawer open). Falls back to a full reload on any error.
 */
(function () {
  'use strict';

  if (window.customElements && customElements.get('bundle-remove-button')) return;

  class BundleRemoveButton extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.button = this.querySelector('button');
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.removeBundle();
      });
    }

    removeBundle() {
      if (this.classList.contains('is-loading')) return;

      var keys = (this.getAttribute('data-keys') || '')
        .split('|')
        .filter(function (k) { return k; });
      if (!keys.length) return;

      var updates = {};
      keys.forEach(function (key) { updates[key] = 0; });

      var routes = window.routes || {};
      var updateUrl = routes.cart_update_url || '/cart/update';
      var sectionIds = this.getSectionIds();

      this.setLoading(true);

      fetch(updateUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          updates: updates,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (response) { return response.json(); })
        .then((state) => {
          if (state && state.status && state.status >= 400) {
            throw new Error(state.description || state.message || 'Cart update failed');
          }
          this.renderSections(state && state.sections);
        })
        .catch(() => {
          window.location.reload();
        });
    }

    setLoading(loading) {
      this.classList.toggle('is-loading', loading);
      if (this.button) this.button.disabled = loading;
    }

    getSectionIds() {
      var ids = {};
      var selectors = [
        'cart-drawer',
        'cart-drawer-items',
        'cart-items',
        '#main-cart-items',
        '#main-cart-footer',
        '#cart-icon-bubble',
        'cart-icon-bubble'
      ];
      selectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (el) {
          var section = el.closest('.shopify-section');
          if (section && section.id) {
            ids[section.id.replace('shopify-section-', '')] = true;
          }
        });
      });
      return Object.keys(ids);
    }

    renderSections(sections) {
      if (!sections || typeof sections !== 'object') {
        window.location.reload();
        return;
      }

      var parser = new DOMParser();
      var handled = false;

      Object.keys(sections).forEach(function (id) {
        var target = document.getElementById('shopify-section-' + id);
        var html = sections[id];
        if (!target || html == null) return;

        var doc = parser.parseFromString(html, 'text/html');
        handled = true;

        // Keep the <cart-drawer> element (and its open state) intact by
        // swapping only its inner content when present.
        var freshDrawer = doc.querySelector('cart-drawer');
        var currentDrawer = target.querySelector('cart-drawer');
        if (freshDrawer && currentDrawer) {
          currentDrawer.innerHTML = freshDrawer.innerHTML;
          return;
        }

        // Otherwise replace the whole section body. The Sections API may or may
        // not include the wrapper div, so handle both shapes.
        var wrapper = doc.getElementById('shopify-section-' + id);
        target.innerHTML = wrapper ? wrapper.innerHTML : html;
      });

      if (!handled) {
        window.location.reload();
        return;
      }

      document.dispatchEvent(new CustomEvent('bundle:removed', { bubbles: true }));
    }
  }

  customElements.define('bundle-remove-button', BundleRemoveButton);
})();
